import GameTree from './gameTree';
import Node from './node';
import Property from './property';
import Sgf from './sgf';

class Parser {

  static upperCase = "BWCADEFGHIJKLMNOPQRSTUVXYZ";

  constructor() {
    this.tmpPropIdent = "";
    this.tmpValue = "";
    this.sgf = new Sgf();
    this.gameTree = undefined;
    this.node = undefined;
    this.property = undefined;
    /**
     * true if the previous character is escape(\).
     */
    this.escape = false;
    /**
     * true while parsing property value, i.e. inside []
     */
    this.parsingPropValue = false;
    /**
     * current branch; Collection or GameTree
     */
    this.currentBranch = this.sgf.collection;
  }

  parse(inputStr) {
    if (!inputStr) {
      throw new Error("No input data.");
    }
    for (const ch of inputStr) {
      this.processCharacter(ch);
    }
    this.sgf.gameTreeIndex = [0];
    return this.sgf;
  }

  processCharacter(ch) {
    if (this.escape) {
      this.escape = false;
      this.tmpValue += ch;
    } else if (ch === '\\' && this.parsingPropValue) { // make escape true
      this.escape = true;
      this.tmpValue += ch;
    } else if (ch === ']' && this.node) {
      this.endPropValue();
    } else if (this.parsingPropValue) {
      this.tmpValue += ch;
    } else if (ch === '[' && this.node) {
      this.beginPropValue();
    } else if (ch === '(') {
      this.beginGameTree();
    } else if (ch === ';') {
      this.beginNode();
    } else if (ch === ')') {
      this.endGameTree();
    } else if (this.gameTree && this.isUcLetter(ch)) {
      this.appendPropIdent(ch);
    }
  }

  isUcLetter(ch) {
    return Parser.upperCase.indexOf(ch) > -1;
  }

  beginGameTree() {
    this.gameTree = new GameTree();
    this.currentBranch.addChild(this.gameTree);
    this.currentBranch = this.gameTree;
  }

  endGameTree() {
    if (!this.gameTree) {
      console.error("No start GameTree parenthesis.");
      this.beginGameTree();
    }
    // Remove empty Nodes
    this.gameTree.nodes = this.gameTree.nodes.filter(node =>
      node.properties.length > 0);
    this.currentBranch = this.gameTree.parent;
    // If this GameTree is empty, remove from the parent.
    if (!this.gameTree.nodes && !this.gameTree.children) {
      console.warn("GameTree is empty.");
      this.currentBranch.removeChild(this.gameTree);
    }
    // set the current gameTree.
    this.gameTree = this.currentBranch instanceof GameTree
      ? this.currentBranch : null;
    this.property = null;
    this.resetTempProperty();
  }

  beginNode() {
    if (!this.gameTree) {
      console.error("No start GameTree parenthesis");
      this.beginGameTree();
    }
    this.node = new Node();
    this.gameTree.add(this.node);
    this.resetTempProperty();
  }

  /**
   * Called at endPropValue or beginNode.
   */
  resetTempProperty() {
    this.tmpPropIdent = "";
    this.tmpValue = "";
    this.parsingPropValue = false;
    this.escape = false;
  }

  appendPropIdent(ch) {
    // Some wrong sgf data don't have the first node begin mark(;).
    if (!this.node) {
      console.warn("No Node begin mark.");
      this.beginNode();
    }
    this.property = null;
    this.tmpPropIdent += ch;
  }

  beginPropValue() {
    if (!this.property && !this.tmpPropIdent) {
      console.warn("No PropIdent");
      return;
    }
    this.parsingPropValue = true;
  }

  endPropValue() {
    if (!this.parsingPropValue) {
      console.warn("No start PropValue bracket");
      return;
    }
    if (this.property) {
      this.property.add(this.tmpValue);
    } else if (this.node && this.node.contains(this.tmpPropIdent)) {
      this.property = this.node.getProperty(this.tmpPropIdent);
      this.property.add(this.tmpValue);
    } else if (this.tmpPropIdent) {
      this.createProperty();
    } else {
      console.warn("No PropIdent");
    }
    this.resetTempProperty();
  }

  createProperty() {
    this.property = new Property(this.tmpPropIdent, [this.tmpValue]);
    this.node.addProperty(this.property);
  }
}

export default Parser;